import React from "react";
import "./style/style-mob.css";
import VerticalLinearStepper from "../../common/stepper/VerticalLinearStepper";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import { host } from "../../config/Config";

export const Reservation = () => {
    const [language, setLanguage] = React.useState("10"); // Default to "10" (Srpski)
    const [showEmailDialog, setShowEmailDialog] = React.useState(false);
    const [email, setEmail] = React.useState("");

    React.useEffect(() => {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }

        const handleStorageChange = () => {
            setLanguage(localStorage.getItem("selectedLanguage") || "10");
        };

        window.addEventListener("storage", handleStorageChange);

        // Check if user should see email dialog
        const token = localStorage.getItem("zajednica-token");
        const isEducationUser =
            localStorage.getItem("zajednica-is-education-user") === "true";
        const userEmail = localStorage.getItem("zajednica-email");
        const hasSeenEmailDialog = localStorage.getItem(
            "zajednica-email-dialog-shown"
        );

        // Pre-fill email if it exists in localStorage
        if (userEmail) {
            setEmail(userEmail);
        }

        // Show dialog if: user is logged in, not education user, no email stored, and hasn't seen dialog
        if (token && !isEducationUser && !userEmail && !hasSeenEmailDialog) {
            setShowEmailDialog(true);
        }

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const handleContinue = async () => {
        if (email.trim()) {
            // Save to localStorage
            localStorage.setItem("zajednica-email", email.trim());

            // Dispatch custom event to notify other components
            window.dispatchEvent(new Event("emailUpdated"));

            // Save to database
            const token = localStorage.getItem("zajednica-token");
            if (token) {
                try {
                    const response = await fetch(
                        `${host}/api/v1/users/update-email`,
                        {
                            method: "PUT",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({ email: email.trim() }),
                        }
                    );

                    if (!response.ok) {
                        console.error("Failed to update email in database");
                    }
                } catch (error) {
                    console.error("Error updating email:", error);
                }
            }
        }
        localStorage.setItem("zajednica-email-dialog-shown", "true");
        setShowEmailDialog(false);
    };

    return (
        <div className='barber-zajednica-reservation-page'>
            <div className='barber-zajednica-reservation-background'></div>

            <div className='barbershop-zajednica-reservation-title'>
                {language == 20 ? "Reserve Appointment" : "Rezervacija Termina"}
            </div>
            <div className='barbershop-zajednica-reservation-picker'>
                <VerticalLinearStepper />
            </div>
            <div className='barbershop-zajednica-reservation-footer' />

            {/* Email Dialog */}
            <Dialog
                open={showEmailDialog}
                onClose={handleContinue}
                maxWidth='sm'
                fullWidth
                PaperProps={{
                    style: {
                        backgroundColor: "#1a1a1a",
                        backgroundImage:
                            "linear-gradient(145deg, #1a1a1a 0%, #2d2d2d 100%)",
                        borderRadius: "12px",
                        border: "1px solid #be9455",
                        boxShadow: "0 8px 32px rgba(190, 148, 85, 0.3)",
                    },
                }}
            >
                <DialogTitle style={{ paddingBottom: "1px" }}></DialogTitle>
                <DialogContent
                    style={{ paddingTop: "16px", paddingBottom: "24px" }}
                >
                    <Typography
                        variant='body1'
                        style={{
                            marginBottom: "24px",
                            color: "#e0e0e0",
                            fontSize: "16px",
                            lineHeight: "1.6",
                            textAlign: "center",
                        }}
                    >
                        Radi unapređenja usluge, uvedene su email notifikacije.
                        Unesite vašu email adresu kako biste primali potvrde o
                        rezervacijama.
                    </Typography>
                    <TextField
                        autoFocus
                        margin='dense'
                        label='Email adresa'
                        type='email'
                        fullWidth
                        variant='outlined'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder='vas.email@primer.com'
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                color: "#ffffff",
                                backgroundColor: "rgba(255, 255, 255, 0.05)",
                                "& fieldset": {
                                    borderColor: "#be9455",
                                },
                                "&:hover fieldset": {
                                    borderColor: "#d4a668",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#be9455",
                                    borderWidth: "2px",
                                },
                            },
                            "& .MuiInputLabel-root": {
                                color: "#be9455",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                                color: "#be9455",
                            },
                        }}
                    />
                </DialogContent>
                <DialogActions
                    style={{ padding: "16px 24px", justifyContent: "center" }}
                >
                    <Button
                        onClick={handleContinue}
                        variant='contained'
                        fullWidth
                        style={{
                            backgroundColor: "#be9455",
                            color: "#ffffffff",
                            textTransform: "none",
                            fontSize: "16px",
                            padding: "12px 32px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            boxShadow: "0 4px 12px rgba(190, 148, 85, 0.4)",
                            maxWidth: "300px",
                        }}
                        sx={{
                            "&:hover": {
                                backgroundColor: "#d4a668",
                                boxShadow: "0 6px 16px rgba(190, 148, 85, 0.5)",
                            },
                        }}
                    >
                        Nastavi dalje
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
